// extracted by mini-css-extract-plugin
export var backupIcon = "_sp-1";
export var image = "_sp-0";